module.exports = __webpack_public_path__ + "static/cateau2-a16ea34d87f76a1d1098409c1a1678d9.webp";